import { render, staticRenderFns } from "./NsCard.vue?vue&type=template&id=3cebf675&scoped=true&"
import script from "./NsCard.vue?vue&type=script&lang=js&"
export * from "./NsCard.vue?vue&type=script&lang=js&"
import style0 from "./NsCard.vue?vue&type=style&index=0&id=3cebf675&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cebf675",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
